module.exports = __webpack_public_path__ + "static/media/paperBox.e0e17bf9.png";